import React, {useEffect, useState} from 'react';
import {Grid,} from '@material-ui/core';

import {CategoryCards, DashboardHeader, OrdersDataTable} from '../../../components'
import './style.scss'
import {myOrderHeadCells, ordersForMeHeadCells} from './constant'
import HttpService from '../../../services/http.service';
import {getUserDataFromLocalStorage} from "../../../services/utils";


function Index(props) {
  let loginUser = getUserDataFromLocalStorage()
  const [activeCat, setActiveCat] = useState('my orders')
  // let [column] = activeCat === 'my orders' ? [myOrderHeadCells] : [ordersForMeHeadCells]
  let [column] = activeCat === 'my orders' ? [myOrderHeadCells] : [myOrderHeadCells]

  const [loading, setLoading] = useState(true)
  const [myOrder, setMyOrder] = useState([])
  const [order, setOrder] = useState([])
  useEffect(() => {
    setLoading(true)
    HttpService.get('api/orders/listAllActiveorders/ssoId/' + loginUser.ssoId).then(res => {
      if (res) {
        setMyOrder(res.data)
        setLoading(false)
      }
    });
    HttpService.get('api/orders/listAllActiveordersForMe/ssoId/' + loginUser.ssoId).then(res => {
      if (res) {
        setOrder(res.data)
      }
    });

  }, []);

  const addNewHandler = () => {
    props.history.push('/addservice')
  }


  return (
    <Grid container direction={'column'} className='p-20 content-main-container'>
      <DashboardHeader pageTitle={activeCat == 'my orders' ? 'My Orders' : 'Orders for me'}/>
      <CategoryCards active={activeCat} setActive={setActiveCat} order={true}/>
      <div className="mt-20">
        {
          // (loading) ? <Loader/> :
          //   (usersList && usersList.resp.length > 0) ?
          activeCat == 'my orders' && <OrdersDataTable

            // data={{rows: usersList?.resp, column: headCells,}}
            // data={{rows: data, column: servicesHeadCells,}}
            data={{
              // rows:activeCat==='vendor'? vendorsData:servicesData ,
              // rows: {activeCat === 'supplies'&& supplierData},
              rows: myOrder,
              // column:activeCat==='vendor'? vendorsHeadCells:servicesHeadCells,
              column: column,
            }}
            // vendor={activeCat==='vendor'}
            tableName={activeCat}
            addNewHandler={activeCat === 'services' ? addNewHandler : () => {
            }}
            // loading={loading}
            pagination={{
              // totalRows: usersList?.pagination?.rowCount,
              // pageSize: pageSize,
              // onPageSizeChange: onPageSizeChange,
              // pageNo: pageNo - 1,
              // onPageChange: onPageChange
            }}
          />
          // :
          //     (usersList && !usersList.resp.length > 0 && !loading) ? <NoData text={"no data available"}/>
          //       : <Loader/>
        }
        {
          // (loading) ? <Loader/> :
          //   (usersList && usersList.resp.length > 0) ?
          activeCat != 'my orders' && <OrdersDataTable

            // data={{rows: usersList?.resp, column: headCells,}}
            // data={{rows: data, column: servicesHeadCells,}}
            data={{
              // rows:activeCat==='vendor'? vendorsData:servicesData ,
              // rows: {activeCat === 'supplies'&& supplierData},
              rows: order,
              // column:activeCat==='vendor'? vendorsHeadCells:servicesHeadCells,
              column: column,
            }}
            // vendor={activeCat==='vendor'}
            tableName={activeCat}
            addNewHandler={activeCat === 'services' ? addNewHandler : () => {
            }}
            // loading={loading}
            pagination={{
              // totalRows: usersList?.pagination?.rowCount,
              // pageSize: pageSize,
              // onPageSizeChange: onPageSizeChange,
              // pageNo: pageNo - 1,
              // onPageChange: onPageChange
            }}
          />
          // :
          //     (usersList && !usersList.resp.length > 0 && !loading) ? <NoData text={"no data available"}/>
          //       : <Loader/>
        }
      </div>

    </Grid>
  );
}

export default Index;
